import { Card, CardHeader, Typography } from "@mui/material";
import { MdMoney } from "react-icons/md";

const PointsHeader = () => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            معاملات النقاط
          </Typography>
        }
        avatar={<MdMoney size={20} />}
      />
    </Card>
  );
};

export default PointsHeader;
